import { Component } from '@angular/core';

@Component({
    selector: 'app-mobile-side-menu',
    templateUrl: './mobile-side-menu.component.html',
    styleUrl: './mobile-side-menu.component.scss',
    standalone: false
})
export class MobileSideMenuComponent {
  mobileMenuOpen: boolean;

  close() {
    this.mobileMenuOpen = false;
  }

  toggleMobileMenu(){
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

}
